export const getDocLastEngagementInitialValues = () => [
  '• Most recent ELT engagement – date and HP executive met with – actions/status',
  '• 2nd most recent ELT engagement – date and HP executive met with – actions/status',
  '• 3rd most recent ELT engagement – date and HP executive met with – actions/status',
]
